import { SvgIcon, SvgIconProps } from '@mui/material'

export function FinancingIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833374 8C0.833374 4.04196 4.042 0.833334 8.00004 0.833334C11.9581 0.833334 15.1667 4.04196 15.1667 8C15.1667 11.958 11.9581 15.1667 8.00004 15.1667C4.042 15.1667 0.833374 11.958 0.833374 8ZM8.00004 1.83333C4.59428 1.83333 1.83337 4.59424 1.83337 8C1.83337 11.4058 4.59428 14.1667 8.00004 14.1667C11.4058 14.1667 14.1667 11.4058 14.1667 8C14.1667 4.59424 11.4058 1.83333 8.00004 1.83333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.11785 6.46796C8.05276 6.40287 7.94724 6.40287 7.88215 6.46796L6.46794 7.88217C6.40285 7.94726 6.40285 8.05279 6.46794 8.11787L7.88215 9.53209C7.94724 9.59718 8.05276 9.59718 8.11785 9.53209L9.53206 8.11787C9.59715 8.05279 9.59715 7.94726 9.53206 7.88217L8.11785 6.46796ZM7.17504 5.76085C7.63065 5.30524 8.36935 5.30524 8.82496 5.76085L10.2392 7.17507C10.6948 7.63068 10.6948 8.36937 10.2392 8.82498L8.82496 10.2392C8.36935 10.6948 7.63065 10.6948 7.17504 10.2392L5.76083 8.82498C5.30522 8.36937 5.30522 7.63068 5.76083 7.17507L7.17504 5.76085Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default FinancingIcon